import { axiosRequest } from '@/util/axios-request';

// 获取薪资项目管理-list
export var payrollManageList = function payrollManageList(data) {
  return axiosRequest({
    url: '/web/payroll_setting/managelist',
    method: 'GET',
    params: data
  });
};
// 编辑群勤奖规则
export var saveFullAttendanceBonus = function saveFullAttendanceBonus(data) {
  return axiosRequest({
    url: '/web/payroll_setting/saveFullAttendanceBonus',
    method: 'POST',
    data: data
  });
};

// 设置薪资项目状态
export var updateSettingStatus = function updateSettingStatus(data) {
  return axiosRequest({
    url: '/web/payroll_setting/updateSettingStatus',
    method: 'POST',
    data: data
  });
};

// 全勤奖设置list
export var fullAttendanceBonusList = function fullAttendanceBonusList(data) {
  return axiosRequest({
    url: '/web/payroll_setting/fullAttendanceBonusList',
    method: 'GET',
    params: data
  });
};